import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { SourceLog } from '@referrals/shared/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SourceLogService {
  private headers: HttpHeaders;
  private accessPointUrl: string;

  constructor(private config: ConfigService, private http: HttpClient) {
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
    });
    this.accessPointUrl = `${this.config.referralsApiUrl}/sourcelogs`;
  }

  public getById(id: number): Observable<SourceLog[]> {
    return this.http.get<SourceLog[]>(this.accessPointUrl + '/' + id, {
      headers: this.headers,
    });
  }
}
